import { PLACEHOLDER } from 'helpers/enums';
import { LagDateInformation } from 'components/LagDateBadge/LagDateBadge';
import { serverDateToFormat } from 'helpers/formatters/date';
import { BenchmarkMetadataDefaultDisplayTestIds } from 'helpers/testIds';
import { PullForward } from 'types/PullForward';

type Properties = {
  benchmark: PullForward;
};

const customColumn = {
  width: 180,
};

export const DefaultDisplay = ({ benchmark }: Properties) => {
  const { badge, date } = LagDateInformation({
    isLagged: benchmark.isLagged,
    defaultLagDate: benchmark.defaultLagDate,
    customLagDate: benchmark.customLagDate,
  });

  return (
    <div className='d-none d-md-none d-lg-block'>
      <div className='col'>
        <div className='row'>
          <table className='table table-borderless table-responsive'>
            <thead>
              <tr>
                <th scope='col'>ID</th>
                <th scope='col'>Benchmark Type</th>
                <th scope='col'>Base Currency</th>
                <th scope='col'>Calculation Frequency</th>
                <th scope='col'>Inception</th>
                <th scope='col'>Created</th>
                {benchmark.isLagged ? (
                  <th scope='col'>Lag Date {badge}</th>
                ) : null}
                {benchmark?.calculationFrequency?.id === 1 ? (
                  <th style={customColumn}>Calendar Type</th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-testid={BenchmarkMetadataDefaultDisplayTestIds.Id}>
                  {benchmark?.id}
                </td>
                <td data-testid={BenchmarkMetadataDefaultDisplayTestIds.Type}>
                  {benchmark?.type?.name}
                </td>
                <td
                  data-testid={
                    BenchmarkMetadataDefaultDisplayTestIds.BaseCurrency
                  }
                >
                  {benchmark?.baseCurrencyCode}
                </td>
                <td
                  data-testid={
                    BenchmarkMetadataDefaultDisplayTestIds.CalculationFrequency
                  }
                >
                  {benchmark?.calculationFrequency?.name}
                </td>
                <td
                  data-testid={
                    BenchmarkMetadataDefaultDisplayTestIds.InceptionDate
                  }
                >
                  {benchmark?.inceptionDate
                    ? serverDateToFormat(benchmark.inceptionDate)
                    : ''}
                </td>
                <td
                  data-testid={
                    BenchmarkMetadataDefaultDisplayTestIds.CreatedDate
                  }
                >
                  {benchmark?.createdDate
                    ? serverDateToFormat(benchmark?.createdDate)
                    : ''}
                </td>
                {benchmark.isLagged ? (
                  <td
                    data-testid={BenchmarkMetadataDefaultDisplayTestIds.LagDate}
                  >
                    {date}
                  </td>
                ) : null}
                {benchmark?.calculationFrequency?.id === 1 ? (
                  <td
                    data-testid={
                      BenchmarkMetadataDefaultDisplayTestIds.PACalendar
                    }
                  >
                    {benchmark?.portfolioAnalyticsCalendar
                      ? benchmark?.portfolioAnalyticsCalendar.name
                      : ''}
                  </td>
                ) : null}
              </tr>
            </tbody>
          </table>
        </div>
        <div className='row'>
          <table className='table table-borderless table-responsive'>
            <thead>
              <tr>
                <th style={customColumn}>Booked Values</th>
                <th style={{ width: 'auto' }}>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  data-testid={
                    BenchmarkMetadataDefaultDisplayTestIds.IncludeBookedValues
                  }
                >
                  {benchmark?.includeBookedValues ? 'Included' : 'Not Included'}
                </td>
                <td
                  data-testid={
                    BenchmarkMetadataDefaultDisplayTestIds.Description
                  }
                >
                  {benchmark?.description || PLACEHOLDER.dashes}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
